import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAttributes, GetModelAttribute } from '../../../actions/productActions';
import $ from 'jquery';
import { getLastURL } from '../../../helper';
import { useLocation } from 'react-router';
import { getAllProductsFilter } from '../../../actions/productActions';
import { FormattedMessage, useIntl } from 'react-intl';
import mixpanel from 'mixpanel-browser';
import { set } from 'react-hook-form';

const Sidebar = ({ tabChangeHandler, setShowFilters }) => {


    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = getLastURL(location);
    const { attributes } = useSelector(state => state.attributes);
    const { modelattribute } = useSelector(state => state.ModelAttribute);
    const { products, error, loading } = useSelector(state => state.products);

    useEffect(() => {
        dispatch(getAttributes(pathname))
        dispatch(GetModelAttribute(pathname, [252]))
    }, [dispatch, pathname])

    const [brandCheck, setBrandCheck] = useState(new Array(attributes && attributes.brand && attributes.brand.length).fill(false));
    const [brand, setBrand] = useState([]);
    const [modelCheck, setModelCheck] = useState(new Array(modelattribute && modelattribute && modelattribute.model.length).fill(false));
    const [model, setModel] = useState([]);
    const [price, setPrice] = useState({
        from: "",
        to: ""
    })
    const [year, setYear] = useState({
        from: "",
        to: ""
    })
    const [case_size, setCaseSize] = useState({
        from: "",
        to: ""
    });
    const [paperCheck, setPaperCheck] = useState(new Array(attributes && attributes.papers_box && attributes.papers_box.length).fill(false));
    const [paper, setPaper] = useState([]);
    const [conditionCheck, setConditionCheck] = useState(new Array(attributes && attributes.condition && attributes.condition.length).fill(false));
    const [condition, setCondition] = useState([]);
    const [genderCheck, setGenderCheck] = useState(new Array(attributes && attributes.gender && attributes.gender.length).fill(false));
    const [gender, setGender] = useState([]);
    const [reference_number, setReferenceNumber] = useState();
    const [movementCheck, setMovementCheck] = useState(new Array(attributes && attributes.movement && attributes.movement.length).fill(false));
    const [movement, setMovement] = useState([]);
    const [functionsCheck, setFunctionsCheck] = useState(new Array(attributes && attributes.functions && attributes.functions.length).fill(false));
    const [functions, setFunctions] = useState([]);
    const [dialnumeralCheck, setDialNumeralCheck] = useState(new Array(attributes && attributes.dial_numerals && attributes.dial_numerals.length).fill(false));
    const [dial_numeral, setDialNumeral] = useState([]);
    const [dialtypeCheck, setDialTypeCheck] = useState(new Array(attributes && attributes.dial_type && attributes.dial_type.length).fill(false));
    const [dial_type, setDialType] = useState([]);
    const [casematerialCheck, setCaseMaterialCheck] = useState(new Array(attributes && attributes.case_material && attributes.case_material.length).fill(false));
    const [case_material, setCaseMaterial] = useState([]);
    const [bezelmaterialCheck, setBezelMaterialCheck] = useState(new Array(attributes && attributes.bezel_material && attributes.bezel_material.length).fill(false));
    const [bezel_material, setBezelMaterial] = useState([]);
    const [strapmaterialCheck, setStrapMaterialCheck] = useState(new Array(attributes && attributes.strap_material && attributes.strap_material.length).fill(false));
    const [strap_material, setStrapMaterial] = useState([]);
    const [strapcolorCheck, setStrapColorCheck] = useState(new Array(attributes && attributes.strap_color && attributes.strap_color.length).fill(false));
    const [strap_color, setStrapColor] = useState([]);
    const [supplierCheck, setSupplierCheck] = useState(new Array(attributes && attributes.top_sellers && attributes.top_sellers.length).fill(false));
    const [supplier, setSupplier] = useState([]);


    const loadMoreDefault = (p_class) => {
        let see_more = localStorage.getItem('lang') === 'tr' ? 'Daha fazla gör' : 'See More';
        let see_less = localStorage.getItem('lang') === 'tr' ? 'Daha Az Gör' : 'See Less';
        if ($('.' + p_class).hasClass('mainclass_hide')) {
            $('.' + p_class).removeClass('mainclass_hide')
            $('.' + p_class + ' .c_hide').hide()
            $('.' + p_class + ' .see_more').html(' <span className="icon-add_1"></span> &nbsp; ' + see_more)
        } else {
            $('.' + p_class + ' .c_hide').show()
            $('.' + p_class).addClass('mainclass_hide')
            $('.' + p_class + ' .see_more').html(' <span className="icon-close_1"></span> &nbsp; ' + see_less)
        }
    }

    const handleFilterBrand = async (position, id) => {

        var tempArray = brand;

        const updatedBrand = brandCheck && brandCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });

        setBrandCheck(updatedBrand);

        // tempArray = [id];
        // if (!tempArray.includes(id)) {
        //      tempArray.push(id);
        //  } else {
        //      tempArray.splice(tempArray.indexOf(id), 1);
        //  }
        //  tempArray.push(id)
        //  dispatch(GetModelAttribute(pathname, brand))
        if (!brand.includes(id)) {
            tempArray.push(id);
            setBrand([...brand, id]);
        } else {
            brand.splice(brand.indexOf(id), 1);
            tempArray.splice(tempArray.indexOf(id), 1);
        }

        await dispatch(GetModelAttribute(pathname, tempArray))




    }


    const handleFilterModel = (position, id) => {
        const updatedModel = modelCheck && modelCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setModelCheck(updatedModel);

        if (!model.includes(id)) {
            setModel([...model, id]);
        } else {
            model.splice(model.indexOf(id), 1);
        }
    }

    const handlePrice = (event) => {
        setPrice({ ...price, [event.target.name]: event.target.value });
    }

    const handleCaseSize = (event) => {
        setCaseSize({ ...case_size, [event.target.name]: event.target.value });
    }

    const handleFilterYear = (event) => {
        setYear({ ...year, [event.target.name]: event.target.value });
    }

    const handleFilterPaper = (position, id) => {
        const updatedPaper = paperCheck && paperCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setPaperCheck(updatedPaper);

        if (!paper.includes(id)) {
            setPaper([...paper, id]);
        } else {
            paper.splice(paper.indexOf(id), 1);
        }
    }


    const handleFilterCondition = (position, id) => {
        const updatedCondition = conditionCheck && conditionCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setConditionCheck(updatedCondition);

        if (!condition.includes(id)) {
            setCondition([...condition, id]);
        } else {
            condition.splice(condition.indexOf(id), 1);
        }
    }


    const handleFilterGender = (position, id) => {
        const updatedGender = genderCheck && genderCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setGenderCheck(updatedGender);

        if (!gender.includes(id)) {
            setGender([...gender, id]);
        } else {
            gender.splice(gender.indexOf(id), 1);
        }
    }

    const handleReferenceNumber = (event) => {
        setReferenceNumber(event.target.value);
    }


    const handleFilterMovement = (position, id) => {
        const updatedMovement = movementCheck && movementCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setMovementCheck(updatedMovement);

        if (!movement.includes(id)) {
            setMovement([...movement, id]);
        } else {
            movement.splice(movement.indexOf(id), 1);
        }
    }

    const handleFilterFunctions = (position, id) => {
        const updatedFunctions = functionsCheck && functionsCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setFunctionsCheck(updatedFunctions);

        if (!functions.includes(id)) {
            setFunctions([...functions, id]);
        } else {
            functions.splice(functions.indexOf(id), 1);
        }
    }



    const handleFilterDialNumeral = (position, id) => {
        const updateDialNumeral = dialnumeralCheck && dialnumeralCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setDialNumeralCheck(updateDialNumeral);

        if (!dial_numeral.includes(id)) {
            setDialNumeral([...dial_numeral, id]);
        } else {
            dial_numeral.splice(dial_numeral.indexOf(id), 1);
        }
    }


    const handleFilterDialType = (position, id) => {
        const updateDialType = dialtypeCheck && dialtypeCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setDialTypeCheck(updateDialType);

        if (!dial_type.includes(id)) {
            setDialType([...dial_type, id]);
        } else {
            dial_type.splice(dial_type.indexOf(id), 1);
        }
    }


    const handleFilterCaseMaterial = (position, id) => {
        const updateCaseMaterial = casematerialCheck && casematerialCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setCaseMaterialCheck(updateCaseMaterial);

        if (!case_material.includes(id)) {
            setCaseMaterial([...case_material, id]);
        } else {
            case_material.splice(case_material.indexOf(id), 1);
        }
    }


    const handleFilterBezelMaterial = (position, id) => {
        const updatebezelmaterial = bezelmaterialCheck && bezelmaterialCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setBezelMaterialCheck(updatebezelmaterial);

        if (!bezel_material.includes(id)) {
            setBezelMaterial([...bezel_material, id]);
        } else {
            bezel_material.splice(bezel_material.indexOf(id), 1);
        }
    }



    const handleFilterStrapMaterial = (position, id) => {
        const updatestrapmaterial = strapmaterialCheck && strapmaterialCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setStrapMaterialCheck(updatestrapmaterial);

        if (!strap_material.includes(id)) {
            setStrapMaterial([...strap_material, id]);
        } else {
            strap_material.splice(strap_material.indexOf(id), 1);
        }
    }



    const handleFilterStrapColor = (position, id) => {
        const updatestrapcolor = strapcolorCheck && strapcolorCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setStrapColorCheck(updatestrapcolor);

        if (!strap_color.includes(id)) {
            setStrapColor([...strap_color, id]);
        } else {
            strap_color.splice(strap_color.indexOf(id), 1);
        }
    }


    const handleFilter = (e) => {
        e.preventDefault();
        mixpanel.track('Watches_filter Jan25');
        tabChangeHandler()
        dispatch(getAllProductsFilter(pathname, { price: price, brand: brand, model: model, case_size: case_size, year: year, papers_box: paper, condition: condition, gender: gender, reference_number: reference_number, movement: movement, functions: functions, dial_numerals: dial_numeral, dial_type: dial_type, case_material: case_material, bezel_material: bezel_material, strap_material: strap_material, strap_color: strap_color, seller: supplier }));
    }

    const handleResetAll = () => {

        setBrandCheck(new Array(attributes && attributes.brand && attributes.brand.length).fill(false));
        setBrand([]);
        setModelCheck(new Array(modelattribute && modelattribute && modelattribute.model.length).fill(false));
        setModel([]);
        setPrice({
            from: "",
            to: ""
        })
        setYear({
            from: "",
            to: ""
        })
        setCaseSize({
            from: "",
            to: ""
        });
        setPaperCheck(new Array(attributes && attributes.papers_box && attributes.papers_box.length).fill(false));
        setPaper([]);
        setConditionCheck(new Array(attributes && attributes.condition && attributes.condition.length).fill(false));
        setCondition([]);
        setGenderCheck(new Array(attributes && attributes.gender && attributes.gender.length).fill(false));
        setGender([]);
        setReferenceNumber();
        setMovementCheck(new Array(attributes && attributes.movement && attributes.movement.length).fill(false));
        setMovement([]);
        setFunctionsCheck(new Array(attributes && attributes.functions && attributes.functions.length).fill(false));
        setFunctions([]);
        setDialNumeralCheck(new Array(attributes && attributes.dial_numerals && attributes.dial_numerals.length).fill(false));
        setDialNumeral([]);
        setDialTypeCheck(new Array(attributes && attributes.dial_type && attributes.dial_type.length).fill(false));
        setDialType([]);
        setCaseMaterialCheck(new Array(attributes && attributes.case_material && attributes.case_material.length).fill(false));
        setCaseMaterial([]);
        setBezelMaterialCheck(new Array(attributes && attributes.bezel_material && attributes.bezel_material.length).fill(false));
        setBezelMaterial([]);
        setStrapMaterialCheck(new Array(attributes && attributes.strap_material && attributes.strap_material.length).fill(false));
        setStrapMaterial([]);
        setStrapColorCheck(new Array(attributes && attributes.strap_color && attributes.strap_color.length).fill(false));
        setStrapColor([]);
        setSupplierCheck(new Array(attributes && attributes.top_sellers && attributes.top_sellers.length).fill(false))
        setSupplier([])
        setReferenceNumber('')
        tabChangeHandler()
        dispatch(getAllProductsFilter(pathname, {}));
    }


    const handleSupplier = (position, id) => {
        const updatedSupplier = supplierCheck && supplierCheck.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setSupplierCheck(updatedSupplier);

        if (!supplier.includes(id)) {
            setSupplier([...supplier, id]);
        } else {
            supplier.splice(supplier.indexOf(id), 1);
        }
    }



            useEffect(() => {
                if (products?.filter && Object.keys(products?.filter).length > 0) {
                    setPrice(products?.filter?.price || [])
                    setYear(products?.filter?.year || [])
                setBrand(products?.filter?.brand?.map(item => item.attribute_id) || [])
                setModel(products?.filter?.model?.map(item => item.attribute_id) || [])
                setPaper(products?.filter?.papers_box?.map(item => item.attribute_id) || [])
                setGender(products?.filter?.gender?.map(item => item.attribute_id) || [])
                setReferenceNumber(products?.filter?.reference_number || '')
                setMovement(products?.filter?.movement?.map(item => item.attribute_id) || [])
                setFunctions(products?.filter?.functions?.map(item => item.attribute_id) || []) 
                setDialNumeral(products?.filter?.dial_numerals?.map(item => item.attribute_id) || [])
                setDialType(products?.filter?.dial_type?.map(item => item.attribute_id) || [])
                setCaseMaterial(products?.filter?.case_material?.map(item => item.attribute_id) || [])
                setBezelMaterial(products?.filter?.bezel_material?.map(item => item.attribute_id) || [])
                setStrapMaterial(products?.filter?.strap_material?.map(item => item.attribute_id) || [])
                setStrapColor(products?.filter?.strap_color?.map(item => item.attribute_id) || [])
                setCondition(products?.filter?.condition?.map(item => item.attribute_id) || [])
                }else{  
                setPrice({ from: "", to: "" })
                setBrand([])
                setModel([])    
                setPaper([])
                setGender([])
                setReferenceNumber('')
                setMovement([])
                setFunctions([])    
                setDialNumeral([])
                setDialType([])
                setCaseMaterial([])
                setBezelMaterial([])
                setStrapColor([])   
                setStrapMaterial([])
                setCondition([])    
                setYear({ from: "", to: "" })
                }
              }, [products?.filter])


    return (
        <div className="col-lg-12">
            <div className="dashboard-sidebar">
                <div className="filter_list Jewelery_list">
                    <form className='side-filter-form' onSubmit={handleFilter}>
                        <div className="filter_side">
                            <div className="filter_top">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fb page_head"><FormattedMessage id="category.watches" defaultMessage="Watches" /></h4>
                                </div>

                                <div className="filter_top mt-3 mb-3 w_brand">
                                    <div className="filter_head">
                                        <h4 className="font-16 black-3B fm"><FormattedMessage id="WatchBrand" defaultMessage="Watch Brand" /></h4>
                                    </div>
                                    <div className="multi_price mt-3">
                                        <div className='filter-labels'>
                                            {
                                                attributes && attributes?.brand && attributes.brand.map((brandData, key) => {
                                                    return (
                                                        <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                            <input type="checkbox" value={brandData.name} checked={brand?.includes(brandData.id)} id={brandData.id} className="checkbox" onChange={() => handleFilterBrand(key, brandData.id)} />
                                                            <label htmlFor={brandData.id}>{brandData.name}</label>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <p id="loadMore" onClick={(e) => loadMoreDefault('w_brand')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                                </div>
                            </div>



                            <div className="filter_top w_model">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="WatchModel" defaultMessage="Watch Model" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            modelattribute && modelattribute && modelattribute.model.map((m, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={m.name} checked={model?.includes(m?.id)} id={m.id} className="checkbox" onChange={() => handleFilterModel(key, m.id)} />
                                                        <label htmlFor={m.id}>{m.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_model')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>


                            <div className="filter_top mb-3">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fb"><FormattedMessage id="addsingleproduct.price" defaultMessage="Price" /></h4>
                                </div>
                                <div className="price_box d-flex">
                                    <div className="form-group mb-0">
                                        <input type="text" placeholder={useIntl().formatMessage({ id: 'Low' })} value={price?.from} name="from" onChange={handlePrice} className="form-control" />
                                    </div>
                                    <span className="icon-minus d-block w-25"></span>
                                    <div className="form-group mb-0">
                                        <input type="text" className="form-control" value={price?.to} name="to" onChange={handlePrice} placeholder={useIntl().formatMessage({ id: 'High' })} />
                                    </div>
                                </div>
                            </div>


                            {/* <div className="filter_top mb-3">
                                        <div className="filter_head">
                                            <h4 className="font-16 black-3B fb">Case Size (mm)</h4>
                                        </div>
                                        <div className="price_box d-flex">
                                            <div className="form-group mb-0">
                                                <input type="text" placeholder={useIntl().formatMessage({id: 'Low'})} value={case_size.from} name="from" onChange={handleCaseSize} className="form-control" />
                                            </div>
                                            <span className="icon-minus d-block w-25"></span>
                                            <div className="form-group mb-0">
                                                <input type="text" className="form-control" value={case_size.to} name="to" onChange={handleCaseSize} placeholder={useIntl().formatMessage({id: 'High'})} />
                                            </div>
                                        </div>
                                    </div> */}


                            <div className="filter_top w_year">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.year" defaultMessage="Year" /></h4>
                                </div>
                                <div className="price_box d-flex">
                                    <div className="form-group mb-0">
                                        <input type="text" placeholder={useIntl().formatMessage({ id: 'Low' })} value={year?.from} name="from" onChange={handleFilterYear} className="form-control" />
                                    </div>
                                    <span className="icon-minus d-block w-25"></span>
                                    <div className="form-group mb-0">
                                        <input type="text" className="form-control" value={year?.to} name="to" onChange={handleFilterYear} placeholder={useIntl().formatMessage({ id: 'High' })} />
                                    </div>
                                </div>
                            </div>



                            <div className="filter_top w_paper">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="PapersAndBox" defaultMessage="Papers & Box" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.papers_box && attributes.papers_box.map((papers_box, key) => {
                                                return (
                                                    <div className={key < 50 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={papers_box.name} checked={paper?.includes(papers_box?.id)} id={papers_box.id} className="checkbox" onChange={() => handleFilterPaper(key, papers_box.id)} />
                                                        <label htmlFor={papers_box.id}>{papers_box.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className="filter_top w_condition">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.condition" defaultMessage="Condition" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.condition && attributes.condition.map((conditions, key) => {
                                                return (
                                                    <div className={key < 50 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={conditions.name} checked={condition.includes(conditions?.id)} id={conditions.id} className="checkbox" onChange={() => handleFilterCondition(key, conditions.id)} />
                                                        <label htmlFor={conditions.id}>{conditions.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className="filter_top w_gender">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.gender" defaultMessage="Gender" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.gender && attributes.gender.map((genderdetails, key) => {
                                                return (
                                                    <div className={key < 50 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={genderdetails.name} checked={gender.includes(genderdetails?.id)} id={genderdetails?.id} className="checkbox" onChange={() => handleFilterGender(key, genderdetails.id)} />
                                                        <label htmlFor={genderdetails.id}>{genderdetails.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className="filter_top mb-3">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fb"><FormattedMessage id="ReferenceNo" defaultMessage="Reference No" />.</h4>
                                </div>
                                <div className="price_box d-flex">
                                    <div className="form-group mb-0">
                                        <input type="text" className="form-control" value={reference_number} name="reference_no" onChange={handleReferenceNumber} placeholder={useIntl().formatMessage({ id: 'ReferenceNo' })} />
                                    </div>
                                </div>
                            </div>


                            <div className="filter_top w_movement">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.movement" defaultMessage="Movement" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.movement && attributes.movement.map((m, key) => {
                                                return (
                                                    <div className={key < 50 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={m.name} checked={movement?.includes(m?.id)} id={m.id} className="checkbox" onChange={() => handleFilterMovement(key, m.id)} />
                                                        <label htmlFor={m.id}>{m.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className="filter_top w_functions">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.functions" defaultMessage="Functions" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.functions && attributes.functions.map((f, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={f.name} checked={functions?.includes(f?.id)} id={f.id} className="checkbox" onChange={() => handleFilterFunctions(key, f.id)} />
                                                        <label htmlFor={f.id}>{f.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_functions')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>


                            <div className="filter_top w_dialnumerals">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="DialNumerals" defaultMessage="Dial Numerals" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.dial_numerals && attributes.dial_numerals.map((dial_numerals, key) => {
                                                return (
                                                    <div className={key < 50 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={dial_numerals.name} checked={dial_numeral?.includes(dial_numerals?.id)} id={dial_numerals.id} className="checkbox" onChange={() => handleFilterDialNumeral(key, dial_numerals.id)} />
                                                        <label htmlFor={dial_numerals.id}>{dial_numerals.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>


                            <div className="filter_top w_dialtype">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.dialtype" defaultMessage="Dial Type" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.dial_type && attributes.dial_type.map((d, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={d.name} checked={dial_type?.includes(d?.id)} id={d.id} className="checkbox" onChange={() => handleFilterDialType(key, d.id)} />
                                                        <label htmlFor={d.id}>{d.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_dialtype')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>



                            <div className="filter_top w_casematerial">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.casematerial" defaultMessage="Case Material" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.case_material && attributes.case_material.map((case_materials, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={case_materials.name} checked={case_material?.includes(case_materials?.id)} id={case_materials.id} className="checkbox" onChange={() => handleFilterCaseMaterial(key, case_materials.id)} />
                                                        <label htmlFor={case_materials.id}>{case_materials.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_casematerial')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>



                            <div className="filter_top w_bezelmaterial">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.bezelmaterial" defaultMessage="Bezel Material" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.bezel_material && attributes.bezel_material.map((bezel_materials, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={bezel_materials.name} checked={bezel_material?.includes(bezel_materials?.id)} id={bezel_materials.id} className="checkbox" onChange={() => handleFilterBezelMaterial(key, bezel_materials.id)} />
                                                        <label htmlFor={bezel_materials.id}>{bezel_materials.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_bezelmaterial')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>



                            <div className="filter_top w_strapmaterial">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.strapmaterial" defaultMessage="Strap Material" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.strap_material && attributes.strap_material.map((strap_materials, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={strap_materials.name} checked={strap_material?.includes(strap_materials?.id)} id={strap_materials.id} className="checkbox" onChange={() => handleFilterStrapMaterial(key, strap_materials.id)} />
                                                        <label htmlFor={strap_materials.id}>{strap_materials.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_strapmaterial')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>


                            <div className="filter_top w_strapcolor">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fm"><FormattedMessage id="addsingleproduct.strapcolor" defaultMessage="Strap Color" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.strap_color && attributes.strap_color.map((strap_colors, key) => {
                                                return (
                                                    <div className={key < 5 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={strap_colors.name} checked={strap_color?.includes(strap_colors?.id)} id={strap_colors.id} className="checkbox" onChange={() => handleFilterStrapColor(key, strap_colors.id)} />
                                                        <label htmlFor={strap_colors.id}>{strap_colors.name}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('w_strapcolor')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>


                            <div className="filter_top mt-3  d_seller">
                                <div className="filter_head">
                                    <h4 className="font-16 black-3B fb"><FormattedMessage id="Supplier" defaultMessage="Supplier" /></h4>
                                </div>
                                <div className="multi_price mt-3">
                                    <div className='filter-labels'>
                                        {
                                            attributes && attributes?.top_sellers && attributes.top_sellers.map((data, key) => {
                                                return (
                                                    <div className={key < 20 ? 'form-group mb-2 c_show' : 'form-group mb-2 c_hide'} key={key}>
                                                        <input type="checkbox" value={data.name} checked={supplierCheck[key]} id={data.id} className="checkbox" onChange={() => handleSupplier(key, data.id)} />
                                                        <label htmlFor={data.id}>{data.name} ({data.product_count})</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <p id="loadMore" onClick={(e) => loadMoreDefault('d_seller')} className="see_more font-14 gray-65"><span className="icon-add_1"></span> &nbsp; <FormattedMessage id="SeeMore" defaultMessage="See More" /></p>
                            </div>
                        </div>
                        <div className="side-filter-foot">
                            <div className="filter_btn">
                                <button className="btn btn-black" onClick={() => { setShowFilters(false) }}><FormattedMessage id="ApplyFilters" defaultMessage="Apply filters" /></button>
                                <p className="font-14 gray-65 text-center mt-3" style={{ cursor: 'pointer' }} onClick={() => { handleResetAll(); setShowFilters(false) }}><FormattedMessage id="Reset_all" defaultMessage="Reset all" /> <span className="icon-close_1"></span></p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    )
}

export default Sidebar
